import { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "./apiUrl";

export const ArchUseAllDays = () => {
  const [item, setItem] = useState([]);

  
  useEffect(() => {
    const fetchResult = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/getArchAllDays.php`);

        setItem(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchResult();
  }, []);

  return item;
};
